<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span
        class="custom-modal-title is-size-5 has-text-centered has-text-weight-semibold"
        >{{ App.ModalEditorApplicability.TITLE }}</span
      >
      <div class="close-button cursor-pointer" @click.stop="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section>
        <b-field
          :label="General.TYPE"
          class="px-20 pb-0"
          customClass="has-text-color-7"
        >
          <b-select
            v-model="nature"
            :disabled="!hasPermissionAdmMaster"
            :expanded="isMobile"
          >
            <option
              v-for="(option, indexOptions) in natureList"
              :key="indexOptions"
              :value="option"
            >
              {{ option }}</option
            >
          </b-select>
        </b-field>

        <template v-if="entitySelect">
          <ApplicabilityPartCapacity
            class="spacing-p-20"
            :modelParts="modelParts"
            :hasPermissionAdmMaster="hasPermissionAdmMaster"
            :hasPermissionAdmPart="hasPermissionAdmPart"
            :hasPermissionAdmCapacity="hasPermissionAdmCapacity"
            @newApplicabilitiesList="setApplicabilitiesList"
          />
        </template>
        <template v-else>
          <b-field :label="General.TYPE_NATURE" class="p-20">
            <b-select v-model="typeNature">
              <option
                v-for="option in typeNatureList"
                :key="option[0]"
                :value="option[1]"
              >
                {{ option[1] }}</option
              >
            </b-select>
          </b-field>
        </template>
      </section>
    </div>
    <footer class="modal-card-foot custom-align-left">
      <div class="buttons" :class="{ 'is-full': isMobile }">
        <b-button
          :type="isContrast ? 'is-white' : 'is-primary'"
          :class="{ 'mr-0': isMobile }"
          :expanded="isMobile"
          @click="applyApplicabilities"
        >
          {{ General.SAVE.toUpperCase() }}
        </b-button>
        <b-button
          :type="isContrast ? 'is-white' : 'is-primary'"
          class="is-outlined"
          :expanded="isMobile"
          @click.stop="$emit('close')"
        >
          {{ General.CANCEL.toUpperCase() }}
        </b-button>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { App, General } from "@/utils/constants";
import {
  USER_PERMISSIONS as userPermissions,
  NATURE_TYPES as typesNature
} from "@/utils/enumerate";
import ApplicabilityPartCapacity from "@/components/ApplicabilityPartCapacity";

export default {
  name: "ModalEditorApplicabilityDoe",
  components: {
    ApplicabilityPartCapacity
  },
  props: {
    modelParts: {
      type: Object,
      default: () => {}
    },
    modelNature: {
      type: String,
      default: () => ""
    },
    onSetParts: {
      type: Function,
      default: () => null
    },
    onSetNature: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      applicabilitiesList: {},
      nature: General.ORGAN_ENTITY,
      typeNature: ""
    };
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    natureList() {
      return [this.General.ORGAN_ENTITY, this.General.LEGAL_NATURE];
    },

    typeNatureList() {
      return Object.entries(typesNature);
    },

    entitySelect() {
      return this.nature === this.General.ORGAN_ENTITY;
    },

    hasPermissionAdmMaster() {
      return this.hasPermission(userPermissions[`MANAGE_DOE_DOC_MODEL_ADM`]);
    },

    hasPermissionAdmPart() {
      return this.hasPermission(userPermissions["MANAGE_DOE_DOC_MODEL_PART"]);
    },

    hasPermissionAdmCapacity() {
      return this.hasPermission(userPermissions["MANAGE_DOE_DOC_MODEL_UNIT"]);
    }
  },

  beforeMount() {
    if (this.hasPermissionAdmMaster && this.modelNature) {
      this.nature = this.General.LEGAL_NATURE;
      this.typeNature = this.modelNature;
    }
  },

  methods: {
    setApplicabilitiesList(applicabilitiesList) {
      this.applicabilitiesList = applicabilitiesList;
    },

    validate() {
      const msg = [];

      if (
        this.applicabilitiesList?.parts?.some(
          part => !part.capacities.length && !part.all_capacities
        )
      )
        msg.push(this.App.ModelsScreen.MESSAGES.EMPTY_CAPACITY);

      if (msg.length > 0) {
        this.snackToast.open({
          message: `${msg.join(", ")}.`,
          type: "is-danger",
          duration: 8000
        });
        return false;
      }
      return true;
    },

    applyApplicabilities() {
      if (this.validate()) {
        this.nature === General.ORGAN_ENTITY
          ? this.onSetParts(this.applicabilitiesList)
          : this.onSetNature({
              nature: this.nature,
              typeNature: this.typeNature
            });
        this.$parent.close();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  min-width: 50vw;
  background-color: $color-1;

  @media only screen and (max-width: $tablet) {
    width: 100%;
  }
}

.modal-content-container {
  overflow: auto;
  max-height: 450px;
}

.custom-align-left {
  justify-content: flex-end;
}

.custom-modal-title {
  flex-grow: 1;
  line-height: 1;
}
</style>
